import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const Container = ({ border, clip, children }: ContainerProps) => (
  <StyledContainer border={border} $noClip={clip === false}>{children}</StyledContainer>
);

export default Container;
